const SvgCommunity2 = (props) => (
  <>
    <circle cx={48} cy={16} r={16} fill={props.p40} />
    <circle cx={16} cy={48} r={16} fill={props.p40} />
    <circle cx={80} cy={48} r={16} fill={props.p40} />
    <circle cx={48} cy={80} r={16} fill={props.p40} />
  </>
);

export default SvgCommunity2;
